package com.wintermar.inspection.feature.presentation.inspection.landing.widget

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.widget.table_container.HeaderTableContainer
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.completed
import inspection.composeapp.generated.resources.conducted
import inspection.composeapp.generated.resources.inspection
import inspection.composeapp.generated.resources.progress
import inspection.composeapp.generated.resources.status
import inspection.composeapp.generated.resources.vessel
import org.jetbrains.compose.resources.stringResource

@Composable
fun InspectionLandingHeader() {
    HeaderTableContainer(
        items = listOf(
            stringResource(Res.string.inspection),
            stringResource(Res.string.vessel),
            stringResource(Res.string.progress),
            stringResource(Res.string.status),
            stringResource(Res.string.conducted),
            stringResource(Res.string.completed)
        )
    )
}
